import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { CoUserUpdateRoleApi } from '../../../../store/features/coUserUpdateRole';

function RoleAgent(props) {
  const [selectedRole, setSelectedRole] = useState('');
  const dispatch = useDispatch();
  const { userId, coUserRoleId, getUserlList } = props;

  const CoUserStatusUpdate = async (roleName) => {
    const CoUserUpdates = dispatch(
      CoUserUpdateRoleApi({
        id: userId,
        requestHeaders: { role_name: roleName },
      }),
    );
    CoUserUpdates
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occurred. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          getUserlList();
        } else if (data?.payload?.status === 400) {
          toast.error(data?.payload?.message);
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const handleRoleChange = (event) => {
    const newRoleName = event.target.value;
    setSelectedRole(newRoleName);
    CoUserStatusUpdate(newRoleName);
  };

  const roles = [
    {
      value: 'admin',
      label: 'Admin',
      description: 'Access to all LiveChat settings, configurations, and management tools.',
    },
    {
      value: 'agent',
      label: 'Agent',
      description: 'Access to Chats, Traffic, Archives, Tickets, and Reports.',
    },
  ];

  useEffect(() => {
    setSelectedRole(coUserRoleId || '');
  }, [coUserRoleId]);

  return (
    <Box className="RoleAgent-Container">
      <Box>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup value={selectedRole} onChange={handleRoleChange}>
            {roles.map((role) => (
              <Box
                key={role.value}
                sx={{
                  marginBottom: '8px',
                  padding: '24px',
                  minWidth: '552px',
                  height: '88px',

                  border: selectedRole === role.value ? '1px solid #148DFD' : '1px solid #E5E9EC',
                  borderRadius: '8px',
                  backgroundColor: selectedRole === role.value ? '#F0F8FF' : '#FFFFFF',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: selectedRole === role.value ? '#148DFD' : '#D5DCE1',
                  }
                }}

              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Radio
                    value={role.value}
                    checked={selectedRole === role.value}
                    sx={{
                      padding: 0,
                      color: '#D5DCE1',
                      '&.Mui-checked': {
                        color: '#148DFD',
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: 16,
                      },
                    }}
                  />
                  <Typography sx={{
                    color: '#061522',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '20px'
                  }}>
                    {role.label}
                  </Typography>
                </Box>
                <Typography sx={{
                  marginTop: '4px',
                  marginLeft: '28px',
                  color: '#556575',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '20px'
                }}>
                  {role.description}
                </Typography>
              </Box>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
}

export default RoleAgent;